import { render, staticRenderFns } from "./GrupoCredores.vue?vue&type=template&id=f2bfc330"
import script from "./GrupoCredores.vue?vue&type=script&lang=js"
export * from "./GrupoCredores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports